import type { ReactNode } from 'react';

export type TArticlePremiumPerksRenderer = () => ReactNode;

let articlePremiumPerksRenderer: TArticlePremiumPerksRenderer | null = null;

export function setArticlePremiumPerksRenderer(renderer: TArticlePremiumPerksRenderer | null) {
  articlePremiumPerksRenderer = renderer;
}

export function getArticlePremiumPerksRenderer(): TArticlePremiumPerksRenderer | null {
  return articlePremiumPerksRenderer;
}
